import { useQuery, type QueryResult } from '@apollo/client';
import { AUTHENTICATION_TYPES } from '@seek/apac-candidate-header-footer/types';

import type { GetUserQuery } from 'src/__generated__/graphql';
import { GET_USER } from 'src/modules/graphql-client/queries/user.graphql';

export const useUser = () => useQuery<GetUserQuery>(GET_USER);

export const useAuthenticationStatus = () => {
  const { loading, data } = useUser();

  if (loading) {
    return AUTHENTICATION_TYPES.AUTH_PENDING;
  }
  if (data?.viewer?._id) {
    return AUTHENTICATION_TYPES.AUTHENTICATED;
  }
  return AUTHENTICATION_TYPES.UNAUTHENTICATED;
};

export const isUserAuthenticated = (user: QueryResult) =>
  Boolean(user?.data?.viewer?._id);
